import { render, staticRenderFns } from "./dr-card-label.vue?vue&type=template&id=62c82350"
import script from "./dr-card-label.vue?vue&type=script&lang=js"
export * from "./dr-card-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports